// extracted by mini-css-extract-plugin
module.exports = {"subnav":"Subnavbar_subnav__3qmxb"};